// extracted by mini-css-extract-plugin
var _1 = "HowItWorksModal-module__grid___ij6pn";
var _2 = "HowItWorksModal-module__title___RvNTN";
export { _1 as "grid", _2 as "title" }
